export default function Hero() {
  return (
    <section 
      id="home"
      className="relative min-h-screen flex items-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/96d065f77b25e878bb20feb2964bd14f.jpg')`
      }}
    >
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-3xl">
          {/* Financing Badge */}
          <div className="inline-flex items-center bg-red-600 text-white px-6 py-3 rounded-full mb-6 shadow-lg">
            <i className="ri-bank-card-line text-2xl mr-3"></i>
            <span className="font-semibold text-lg">Snap Financing Available</span>
          </div>

          <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Quality Tires for Every Journey
          </h2>
          <p className="text-xl md:text-2xl text-gray-200 mb-8 leading-relaxed">
            Seneca Tire Shop offers premium new and used tires with expert installation services. Your safety is our priority with top-quality tire solutions for all vehicles.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <button className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap">
              Shop New Tires
            </button>
            <button className="bg-white hover:bg-gray-100 text-zinc-900 px-8 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap">
              Browse Used Tires
            </button>
          </div>
        </div>
      </div>

      {/* Snap Finance Logo Badge - Bottom Right */}
      <div className="absolute bottom-8 right-8 bg-white rounded-2xl shadow-2xl p-4 w-48">
        <img 
          src="https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/1baf47a7a5e5bceeb5a1ffb7d7e5665b.png" 
          alt="Snap Finance - Financing Available" 
          className="w-full h-auto"
        />
      </div>
    </section>
  );
}
